/*=========================================================================================
  File Name: moduleSubscriptionState.js
  Description: Subscription Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    subscriptionList: [],
    subscriptionCount: "",
    subscriptionPaymentList: [],
    subscriptionPaymentCount: ""
}